import React from "react";
import { Navigate, useRoutes } from "react-router";
import AdminPanelLayout from "../components/admin-panel/admin-panel-layout";
import Login from "../pages/authentication/Login";
import User from "../pages/User/User";
import OfferCode from "../pages/offercode/OfferCode";
import Report from "../pages/report/Report";
import Marketplace from "../pages/marketplace/Marketplace";

export const PrivateRoute = ({ children }) => {
  const user = localStorage.getItem("watchcert_admin_store");
  return user ? children : <Navigate to="/login" />;
};

export const PublicRoute = ({ children }) => {
  const user = localStorage.getItem("watchcert_admin_store");
  return user ? <Navigate to="/" /> : children;
};

const routes = (isLoggedIn) => [
  {
    path: "/login",
    element: !isLoggedIn ? <Login /> : <Navigate to="/" />,
  },
  {
    path: "/",
    element: isLoggedIn ? <AdminPanelLayout /> : <Navigate to="/login" />,
    children: [
      {
        element: <User />,
        path: "/",
        index: true,
      },
      {
        element: <OfferCode />,
        path: "offercode",
        index: true,
      },
      {
        element: <Report />,
        path: "report",
        index: true,
      },
      {
        element: <Marketplace />,
        path: "marketplace",
        index: true,
      },
    ],
  },
];

export default function Routes(props) {
  const { isLoggedIn } = props;
  return useRoutes(routes(isLoggedIn));
}
